import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$slug/organization/departments')({
  component: Outlet
});
